/* eslint-disable @typescript-eslint/no-unused-vars */
import { isClient } from "@/utils/browser";

export const getItemSession = <T>(name: string, defaultValue: T): T => {
  if (!isClient()) return defaultValue;

  const item = window.sessionStorage.getItem(name);
  try {
    return item ? (JSON.parse(item) as T) : defaultValue;
  } catch (error) {
    return (item as unknown as T) || defaultValue;
  }
};

export const setItemSession = (name: string, value: any): void => {
  if (!isClient()) return;

  if (value !== null && value !== undefined) {
    window.sessionStorage.setItem(name, JSON.stringify(value));
  } else {
    window.sessionStorage.removeItem(name);
  }
};

export const removeItemSession = (name: string): void => {
  if (isClient()) {
    window.sessionStorage.removeItem(name);
  }
};
